export default __webpack_public_path__ + "static/media/Screenshot.f333e49a.png";